import { Route, Routes } from "react-router-dom";
import { AdminRoute } from "./components/AdminRoute";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { BugReporterBanner } from "./components/ui/BugReporterBanner";
import { ToastContainer } from "./components/ui/Toast";
import { AdminInvitesPage } from "./pages/AdminInvitesPage";
import { AdminLayoutPage } from "./pages/AdminLayoutPage";
import { AdminSeatsPage } from "./pages/AdminSeatsPage";
import { AdminUsersPage } from "./pages/AdminUsersPage";
import { AuthCallback } from "./pages/AuthCallback";
import { InvitePage } from "./pages/InvitePage";
import { LandingPage } from "./pages/LandingPage";
import { LoginPage } from "./pages/LoginPage";
import { MyReservationsPage } from "./pages/MyReservationsPage";
import { PrivacyPolicyPage } from "./pages/PrivacyPolicyPage";
import { ProfilePage } from "./pages/ProfilePage";
import { SeatsPage } from "./pages/SeatsPage";

function App() {
  return (
    <>
      <ToastContainer />
      <BugReporterBanner />
      <Routes>
        {/* 公開ルート */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/auth/login" element={<LoginPage />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/invite/:token" element={<InvitePage />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />

        {/* 認証必須ルート */}
        <Route element={<ProtectedRoute />}>
          <Route path="/seats" element={<SeatsPage />} />
          <Route path="/my-reservations" element={<MyReservationsPage />} />
          <Route path="/profile" element={<ProfilePage />} />

          {/* 管理者限定ルート */}
          <Route element={<AdminRoute />}>
            <Route path="/admin/users" element={<AdminUsersPage />} />
            <Route path="/admin/invites" element={<AdminInvitesPage />} />
            <Route path="/admin/layout" element={<AdminLayoutPage />} />
            <Route path="/admin/seats" element={<AdminSeatsPage />} />
          </Route>
        </Route>
      </Routes>
    </>
  );
}

export default App;
